/* eslint-disable prettier/prettier */
const state = {
  isSidebarActive: false,
  themeColor: "#95c720"
};

export default state;
